import * as React from 'react';
export const desktopSvg = React.forwardRef(function desktopSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.5 1a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h3.75v1.5h-2a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-2V12h3.75a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3h-9Zm9 1.5h-9A1.5 1.5 0 0 0 2 4v5a1.5 1.5 0 0 0 1.5 1.5h9A1.5 1.5 0 0 0 14 9V4a1.5 1.5 0 0 0-1.5-1.5Z',
    }),
  );
});
desktopSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var desktop = {
  category: 'icon',
  colorable: true,
  name: 'desktop',
  svg: desktopSvg,
};
